module.exports = __webpack_public_path__ + "static/media/DefaultProfileCover.d42cfff5.png";